import * as React from 'react';

import { IconButton } from '@rematter/ui-web';
import {
  Camera,
  CameraOff,
  LucideAlertCircle,
  LucideCircle,
} from 'lucide-react';

import { LineItemPhotoStatus } from '~/modules/trade/types/load';

type Props = {
  disabled?: boolean;
  hasPhoto?: boolean;
  photoStatus?: LineItemPhotoStatus;
  onPress: () => void;
};

const iconByPhotoStatus: Record<string, React.ReactElement> = {
  error: (
    <LucideAlertCircle
      className="absolute top-2 right-1 fill-failure text-white"
      size={12}
    />
  ),
  captured: (
    <LucideCircle
      className="absolute top-2.5 right-1 fill-success text-white"
      size={8}
    />
  ),
};

export const CameraButton: React.FC<Props> = ({
  disabled,
  hasPhoto,
  photoStatus,
  onPress,
}) => {
  const icon = hasPhoto ? (
    <Camera size={18} className="text-success" />
  ) : (
    <CameraOff size={18} className="text-neutral/40" />
  );

  const statusIndicator = photoStatus ? iconByPhotoStatus[photoStatus] : null;

  return (
    <div className="@CameraButton relative inline-block h-full">
      {statusIndicator}
      <IconButton
        icon={icon}
        className="size-input h-full"
        isDisabled={disabled}
        variant="ghost"
        onPress={onPress}
      />
    </div>
  );
};
